import React from "react";

import { TableFooter, TableRow } from "../helper";
import ChallanTablePagination from "./ChallanTablePagination";

export default function ChallanTableFooter({ ...rest }) {
  return (
    <TableFooter>
      <TableRow>
        <ChallanTablePagination {...rest} />
      </TableRow>
    </TableFooter>
  );
}
